import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, EDIT_SLIDER, CREATE_SLIDER, DELETE_SLIDER } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing PUT request and response contract. */
export function editSlider(fd, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_SLIDER}`, fd, configReq(token));
}

/** Keeps the existing POST request and response contract. */
export function createSlider(fd, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_SLIDER}`, fd, configReq(token));
}

/** Keeps the existing DELETE request and response contract. */
export function deleteSlider(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_SLIDER}?id=${data.id}`, configReq(token));
}
